import _ from 'lodash'
import store from '@/stores/'
const langValue = function () {
  return Object.assign({}, store.state.setting.lang.langValue)
}

const files = require.context('.', false, /\.js$/)
const moduleList = {}
/**
 * 기본설정에서 사용할 세팅옵션
 * link,
 * background,
 * padding,
 * border
 * ...
 */
const defaultSetData = {
  link: {
    active: false,
    type: 'outlink',
    url: langValue(),
    pageId: '', // 링크 기본값
    productId: '',
    target: false
  },
  background: {
    active: false,
    value: '',
    size: 'auto',
    repeat: 'no-repeat',
    position: '50% 50%',
    color: 'rgba(255, 255, 255, 1)'
  },
  padding: { // 0: 0, 15: 기본(15px), 30: 넓게(30px)
    active: true,
    tb: '15',
    lr: '15'
  },
  border: {
    active: false,
    style: 'solid',
    color: 'rgba(0, 0, 0, 1)'
  },
  text: {
    active: false,
    color: 'rgba(62, 62, 62, 1)'
  },
  color: {
    active: false,
    color: 'rgba(62, 62, 62, 1)'
  },
  flex: {
    alignItems: 'center'
  },
  columns: {
    alignItems: 'center',
    padding: {
      tb: '8',
      lr: '8'
    }
  },
  fullsize: {
    active: false,
    alignItems: 'center'
  }
}

const defaultDetailData = {
  carousel: {
    auto: true,
    duration: 3000,
    alignment: 'flex-start'
  },
  link: {
    type: 'outlink',
    url: langValue(),
    pageId: '',
    target: false
  },
  rate: {
    type: 'star',
    color: 'rgba(255,188,0,1)'
  },
  division: {
    width: 1,
    style: 'solid',
    color: 'rgba(62, 62, 62, 1)'
  },
  clock: {
    type: 'digital',
    align: 'center',
    size: 4,
    ampm: true,
    hour24: false
  },
  background: {
    value: '',
    color: 'rgba(62, 62, 62, 1)'
  },
  padding: { // 0: 0, 15: 기본(15px), 30: 넓게(30px)
    active: false,
    tb: '0',
    lr: '0'
  },
  border: {
    style: 'solid',
    color: 'rgba(0, 0, 0, 1)'
  },
  text: {
    color: 'rgba(255, 255, 255, 1)'
  },
  color: {
    color: 'rgba(62, 62, 62, 1)'
  },
  colorHex: {
    active: false,
    color: '#000000'
  },
  button: {
    type: 'link', // link, submit, cart
    link: {
      type: 'outlink',
      url: langValue(),
      pageId: '', // 링크 기본값
      productId: '',
      target: false
    },
    submit: null,
    cart: null
  },
  qrcode: {
    type: 'outlink',
    url: langValue(),
    pageId: '',
    target: false
  },
  qrcodeExpired: {
    isActive: false,
    day: 1
  },
  qrcodeSize: {
    size: '256'
  },
  smartvoice: {
    id: ''
  },
  upload: {
    active: false,
    type: 'image'
  },
  radius: {
    active: false,
    tl: '8',
    tr: '8',
    br: '8',
    bl: '8'
  },
  instagramfeed: {
    items: 6,
    cols: 3,
    margin: '4', // 0: 0, 4: 기본(4px), 8: 넓게(8px)
    caption: 'none', // none: 표시안함, overlay: 이미지에 겹쳐서, bottom: 이미지 아래
    permalink: false
  }
}

// index.js를 제외한 모든 js를 file명을 키로 modules에 담아 리턴
function setFiles (callback) {
  files.keys().forEach((key, index) => {
    if (key === './index.js') return
    moduleList[key.toLowerCase().replace(/(\.\/|\.js)/g, '')] = files(key).default
  })
  callback()
}

// basic setting options
function setBasicOption () {
  // 추가되는 옵션에 대한 데이터 맵핑 할 모듈
  const labelFontSize = /input|textarea|radio|checkbox|select|rate|cert|postcode|signaturepad|calendar/
  for (let i in moduleList) {
    // 기본 세팅 매칭 설정 (모듈마다 설정 가능한 요소가 다름)
    let settingOption = moduleList[i].setting.layout
    let optionData = {}
    settingOption.options.forEach(function (x) {
      let addData = {}
      addData[x] = defaultSetData[x]
      optionData = Object.assign({}, optionData, addData)
    })
    settingOption = _.merge(settingOption, optionData)

    // 링크 모듈에서 외부링크일 때 기본값 설정
    if (moduleList[i].name === 'link') {
      moduleList[i].setting.action.link = Object.assign({}, defaultSetData.link)
    }
    // 모든 모듈에 컬럼이 나뉘어 있으면 비율을 계산할 수 있는 기본값 설정
    if (moduleList[i].dataSet.column.length > 1) {
      moduleList[i].dataSet.column.forEach(function (c) {
        c.flex = 1
      })
    }
    // 디테일 모듈 기본값 설정
    if (moduleList[i].setting.detail !== null) {
      let detailModule = moduleList[i]
      detailModule.dataSet.column.forEach(function (c) {
        let settingOption = c.detail
        let optionData = {}
        settingOption.options.forEach(function (x) {
          let addData = {}
          addData[x] = defaultDetailData[x]
          optionData = Object.assign({}, optionData, addData)
        })
        settingOption = _.merge(settingOption, optionData)
      })
    }
  }
}

setFiles(setBasicOption)

export default moduleList
